const ENDPOINT = process.env.REACT_APP_ENDPOINT

const checkMatch = async (actor_id,media_id) => {
    try {
        const response = await fetch(`${ENDPOINT}/actor_media_overlap/?media=${media_id}&actor=${actor_id}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            },
        })
        if (!response.ok) {
            throw new Error(`Network response was not ok: ${response.status}`);
        }
        const resp = await response.json();
        return resp.overlap;
    } 
    catch (error) {
        console.error('Error checking match:', error);
    }
}

export default checkMatch;